/**
 * 成功路由
 * 2017-12-6
 */
"use strict";
angular.module("successRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("register.success",{
        url:"/success",
        views:{
            "main@register": {
                templateUrl: "./login/register/success/success_tpl.html",
                controller: "successCtrl"
            }
        }
    });
}]);